// extracted by mini-css-extract-plugin
export default {"secondary":"secondary-Xxg1T"};